import { FC } from 'react';

import { SolicitacaoLink } from 'view/section/SolicitacaoLink/SolicitacaoLink';
import { H2 } from 'view/component/Tipografia/Texto';

import styled from 'styled-components';

import { SolicitacaoServicoPageViewProps } from '../SolicitacaoServicoPage';
import { SolicitacaoServicoPageBotoesAcoes } from './SolicitacaoServicoPageBotoesAcoes';
import { SolicitacaoServicoPageHeaderDetalhes } from './SolicitacaoServicoPageDetalhes';


interface SolicitacaoServicoPageHeaderProps extends SolicitacaoServicoPageViewProps {}

export const SolicitacaoServicoPageHeader: FC<SolicitacaoServicoPageHeaderProps> = ({idSolicitacao, solicitacao, ...props}) => {
  const titulo = idSolicitacao
      ? <>Solicitação <SolicitacaoLink solicitacao={idSolicitacao} /></> 
      : <>Nova solicitação de serviço</>;
  
  return <Header {...props}>
    <div>
      <H2>{titulo}</H2>
      <SolicitacaoServicoPageHeaderDetalhes idSolicitacao={idSolicitacao} solicitacao={solicitacao} />
    </div>

    { idSolicitacao && <SolicitacaoServicoPageBotoesAcoes idSolicitacao={idSolicitacao} solicitacao={solicitacao} /> }
  </Header>
}

const Header = styled.header`
  display: flex;
  justify-content: space-between;
`;
